import { CertificationStatus } from '../../enums';

export interface ICertificationAssetSchema {
    url: string;
    timestamp: string;
    comment?: string;
}

export interface ICertificationCommentSchema {
    timestamp: string;
    comment?: string;
}

export interface IItemCertificationSchema {
    type: string;
    value: number;
}

export interface ICertificationItemSchema {
    orderItemId: string;
    certifications: IItemCertificationSchema[];
}

export interface ICertificationRefSchema {
    order?: string;
    trip?: string;
    checkpointIndex?: number;
}

export interface ICertifiedBySchema {
    driver?: string;
    userId?: string;
    name?: string;
}

export interface IUpdatedBySchema {
    userId?: string;
    name?: string;
}

export interface ICertificationInterface {
    id: string;
    ref: ICertificationRefSchema;
    certifiedAt: string;
    certifiedBy: ICertifiedBySchema;
    status: CertificationStatus;
    photos: ICertificationAssetSchema[];
    signatures: ICertificationAssetSchema[];
    comments: ICertificationCommentSchema[];
    items: ICertificationItemSchema[];
    updatedBy: IUpdatedBySchema;
}
